"use client";

import * as React from "react";
import { CircleCheck as CheckCircle2 } from 'lucide-react';
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Calendar } from "@/components/ui/calendar";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { cn } from "@/lib/utils";
const TIME_SLOTS = ["08:00 AM", "09:00 AM", "10:00 AM", "11:00 AM", "12:00 PM", "01:00 PM", "02:00 PM", "03:00 PM", "04:00 PM"];
function BookingFormContent() {
  const {
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <Card className="max-w-2xl mx-auto text-center py-12 shadow-lg border-ring/20">
        <CardContent className="flex flex-col items-center space-y-4">
          <div className="size-16 rounded-lg bg-accent flex items-center justify-center mb-4">
            <CheckCircle2 className="size-8 text-ring" />
          </div>
          <CardTitle className="text-2xl font-default text-foreground">Booking Confirmed!</CardTitle>
          <CardDescription className="text-base max-w-md mx-auto">
            {successMessage}
          </CardDescription>
          <Button onClick={resetForm} variant="outline" className="mt-6">
            Book Another Service
          </Button>
        </CardContent>
      </Card>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        {}
        <div className="lg:col-span-5"></div>

        {}
        <div className="lg:col-span-7 space-y-6">
        </div>
      </div>
    </Form>;
}
export default function ServiceBookingCalendar() {
  return <section id="servicebookingcalendar" className="bg-background py-16 !h-[1000px] md:py-24">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 font-default tracking-tight">
            Schedule Your Cleaning
          </h2>
          <p className="text-lg text-muted-foreground">
            Select your preferred date, time, and service tier below. Our network of professionals will handle the rest.
          </p>
        </div>

        <FormProvider formId="service-booking-calendar" sectionName="Booking Calendar" defaultValues={{
        date: undefined,
        time: ""
      }} submitText="Confirm Booking" successMessage="Thank you for booking with Summit Cleaners! We will contact you shortly to confirm your appointment details.">
          <BookingFormContent />
        </FormProvider>
      </div>
    </section>;
}